<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <div>
                    <app-saved-dashboard-view
                        [options]="savedDashboardViewComponentOptions"
                    ></app-saved-dashboard-view>
                </div>
                <div *ngFor="let link of [modify_time_master_funnel]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>
                <div class="revenue-settings">
                    <div
                        style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                        "
                    ></div>
                    <div
                        style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                        "
                    >
                        <!-- <div>
                            <app-checkbox
                                [option]="settingItemShowTotalRevenue.options"
                            ></app-checkbox>
                        </div> -->
                    </div>
                </div>
                <!-- <app-string-input-setting
                    [options]="settingMaxDayNoOptions"
                ></app-string-input-setting> -->
                <app-filter-selector
                    [filterDashboardItemLinks]="filterDashboardItemLinks"
                    style="row-gap: 5px; display: flex; flex-direction: column"
                ></app-filter-selector>
                <app-single-select [option]="settingStepCountStrategy.options">
                </app-single-select>
                <app-single-select
                    [option]="settingsOtherGroupingStrategy.options"
                >
                </app-single-select>
                <app-string-input-setting
                    [options]="settingLimitDetailsSteps"
                ></app-string-input-setting>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <nz-alert
            nzType="warning"
            nzMessage="Warning - Prototyp"
            [nzDescription]="dashDescriptionTemplate"
            nzShowIcon
        ></nz-alert>
        <ng-template #dashDescriptionTemplate>
            <p>
                Dashboard został zatrzymany w fazie prototypu. Zachowaj
                ostrożność przy wyciąganiu wniosków. Staraliśmy się wyczyścić
                dane jak najbardziej, ale nie możemy zagwarantować ich
                poprawności. Przykładem zaburzenia może być event CutsceneStart,
                który jest ponownie wysyłany po minimalizacji apki w trakcie
                cutscenki. Nie wiemy ile jest podobnych sytuacji w innych
                eventach.
            </p>
            <button
                nz-button
                nzSize="small"
                nzType="primary"
                (click)="showDashboardDocumentation()"
            >
                Opis dashboardu
            </button>
        </ng-template>
        <div class="am-dash-legend-card">
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="24">
                    <app-common-legend></app-common-legend>
                </div>
            </div>
        </div>

        <div class="main-container">
            <div class="grid-container">
                <!-- <app-table-dashboard-item
                    [dashboardItem]="table_summary.dashboardItem"
                    [dataLoaderEmitter]="table_summary.dataLoaderEmitter"
                ></app-table-dashboard-item> -->
                <div nz-row [nzGutter]="5">
                    <span nz-typography>Dane od 2024-11-01</span>
                </div>
                <nz-divider
                    class="no-margin"
                    nzPlain="true"
                    [nzText]="'Master funnel stats'"
                    nzOrientation="left"
                >
                </nz-divider>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="24"
                        *ngFor="let link of [master_funnel_cnt]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="24"
                        *ngFor="let link of [master_funnel_step_diff]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="24"
                        *ngFor="let link of [master_funnel_step_diff_first]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <nz-divider
                    class="no-margin"
                    nzPlain="true"
                    [nzText]="'Details stats'"
                    nzOrientation="left"
                >
                </nz-divider>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="24"
                        *ngFor="let link of [master_funnel_details_cnt]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="24"
                        *ngFor="
                            let link of [master_funnel_details_cnt_step_diff]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="24"
                        *ngFor="
                            let link of [
                                master_funnel_details_cnt_step_diff_first,
                            ]
                        "
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div>
                    <!-- <span nz-typography>
                        <p>Wyczyszczone przygody:</p>

                        <code>
                            ChroniclesofMagic, ClockworkTales, ClockworkTalesbc,
                            CrimeSecrets, DemonHunter3, DemonHunter3bc,
                            DemonHunter4, DemonHunter4bc, DemonHunter5bc,
                            Dreamwalker, EndlessFables3, EndlessFables3bc,
                            EndlessFables4, EndlessFables4bc, Enigmatis1,
                            Enigmatis1bc, Enigmatis2, Enigmatis3,
                            Enigmatis3bc</code
                        >
                    </span> -->
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
